import React, { useEffect, useRef } from 'react';

function getSeasonConfig() {
  const now = new Date();
  const m = now.getMonth() + 1;
  const d = now.getDate();
  // Koningsdag: 27 april
  if (m === 4 && d >= 25 && d <= 28) return { season: 'koningsdag', label: 'Koningsdag' };
  // December: winter/snow
  if (m === 12) return { season: 'winter', label: 'Winter' };
  // Summer
  if (m >= 6 && m <= 8) return { season: 'summer', label: 'Zomer' };
  // Autumn
  if (m >= 9 && m <= 11) return { season: 'autumn', label: 'Herfst' };
  // Spring
  return { season: 'spring', label: 'Lente' };
}

function SnowEffect() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const flakes = Array.from({ length: 40 }, () => ({
      x: Math.random() * 272, y: Math.random() * -500,
      r: Math.random() * 2.5 + 1, speed: Math.random() * 0.8 + 0.3,
      drift: Math.random() * 0.4 - 0.2,
    }));
    const draw = () => {
      canvas.width = 272;
      canvas.height = canvas.parentElement?.clientHeight || 800;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      flakes.forEach(f => {
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,0.5)';
        ctx.fill();
        f.y += f.speed;
        f.x += f.drift;
        if (f.y > canvas.height) { f.y = -5; f.x = Math.random() * 272; }
        if (f.x > 272) f.x = 0;
        if (f.x < 0) f.x = 272;
      });
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(animId);
  }, []);
  return <canvas ref={canvasRef} className="absolute inset-0 pointer-events-none z-0" />;
}

function LeafEffect() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {[...Array(6)].map((_, i) => (
        <div key={i} className="absolute text-sm opacity-20 animate-leaf-fall" style={{
          left: `${15 + i * 40}px`, animationDelay: `${i * 1.5}s`, animationDuration: `${8 + i * 2}s`,
        }}>
          {['🍂', '🍁', '🍃'][i % 3]}
        </div>
      ))}
      <style>{`
        @keyframes leafFall { 0% { top: -20px; transform: rotate(0deg) translateX(0); opacity: 0.2; }
          50% { transform: rotate(180deg) translateX(20px); opacity: 0.3; }
          100% { top: 100%; transform: rotate(360deg) translateX(-10px); opacity: 0; } }
        .animate-leaf-fall { animation: leafFall linear infinite; }
      `}</style>
    </div>
  );
}

export function getSidebarSeasonClass(season) {
  switch (season) {
    case 'koningsdag': return 'sidebar-koningsdag';
    case 'summer': return 'sidebar-summer';
    default: return '';
  }
}

export function SeasonalSidebarOverlay({ enabled }) {
  if (!enabled) return null;
  const { season } = getSeasonConfig();
  if (season === 'winter') return <SnowEffect />;
  if (season === 'autumn') return <LeafEffect />;
  return null;
}

export function SeasonalLogoDecoration({ enabled }) {
  if (!enabled) return null;
  const { season } = getSeasonConfig();
  if (season === 'koningsdag') return <span className="absolute -top-2 -right-1 text-[10px]" title="Koningsdag">👑</span>;
  if (season === 'summer') return <span className="absolute -top-2 -right-1 text-[10px]" title="Zomer">☀️</span>;
  return null;
}

export function useCurrentSeason() {
  return getSeasonConfig();
}
